import React from "react";
import classNames from "classnames";
import { BemHelper } from "../../../utils/BemHelper";

type Props = {
  children: React.ReactNode;
  size?: "xs" | "sm" | "md" | "lg" | "xl" | "full";
};

const bem = new BemHelper("container");

export const Container: React.FC<Props> = ({ children, size = "lg" }) => {
  return (
    <div className={classNames(bem.block(), bem.modifier(size))}>
      <div>{children}</div>
    </div>
  );
};
